module.exports = __webpack_public_path__ + "media/bootstrap-icons/dash-square-fill-58b5fc13.svg";